<h1 mat-dialog-title>{{ 'labels.buttons.Add Event' | translate }}</h1>

<mat-dialog-content>
  <form [formGroup]="eventForm">
    <div class="layout-column">
      <mat-form-field>
        <mat-label>{{ 'labels.inputs.Select Grouping' | translate }}</mat-label>
        <mat-select required formControlName="grouping">
          @for (grouping of data.groupings; track grouping) {
            <mat-option [value]="grouping.name">
              {{ grouping.name | translateKey: 'catalogs' }}
            </mat-option>
          }
        </mat-select>
        @if (eventForm.controls.grouping.hasError('required')) {
          <mat-error>
            {{ 'labels.inputs.Grouping' | translate }} {{ 'labels.commons.is' | translate }}
            <strong>{{ 'labels.commons.required' | translate }}</strong>
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'labels.inputs.Select Entity' | translate }}</mat-label>
        <mat-select required formControlName="entity">
          @for (entity of entityData; track entity) {
            <mat-option [value]="entity.name">
              {{ entity.name }}
            </mat-option>
          }
        </mat-select>
        @if (eventForm.controls.entity.hasError('required')) {
          <mat-error>
            {{ 'labels.inputs.Entity' | translate }} {{ 'labels.commons.is' | translate }}
            <strong>{{ 'labels.commons.required' | translate }}</strong>
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'labels.inputs.Select Action' | translate }}</mat-label>
        <mat-select required formControlName="action">
          @for (action of actionData; track action) {
            <mat-option [value]="action">
              {{ action }}
            </mat-option>
          }
        </mat-select>
        @if (eventForm.controls.action.hasError('required')) {
          <mat-error>
            {{ 'labels.inputs.Action' | translate }} {{ 'labels.commons.is' | translate }}
            <strong>{{ 'labels.commons.required' | translate }}</strong>
          </mat-error>
        }
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'labels.buttons.Cancel' | translate }}</button>
  <button mat-raised-button color="primary" [disabled]="!eventForm.valid || eventForm.pristine" (click)="submit()">
    {{ 'labels.buttons.Submit' | translate }}
  </button>
</mat-dialog-actions>
